import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CashReceiptPaymentTableModel } from 'src/app/models/tables/wallet/cash-receipt-payment-table.model';
import { CashReceiptTableModel } from 'src/app/models/tables/wallet/cash-receipt-table.model';
import { InvoiceCashReceiptTableModel } from 'src/app/models/tables/wallet/invoice-cash-receipt-table.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CashReceiptPaymentService } from 'src/app/services/wallet/cash-receipt-payment.service';
import { CashReceiptService } from 'src/app/services/wallet/cash-receipt.service';
import { InvoiceCashReceiptService } from 'src/app/services/wallet/invoice-cash-receipt.service';

@Component({
  selector: 'app-cash-receipt',
  templateUrl: './cash-receipt.component.html',
  styleUrls: ['./cash-receipt.component.scss'],
  standalone: false
})
export class CashReceiptComponent implements OnInit {

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<CashReceiptTableModel> = new PagedResponseModel<CashReceiptTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  invoiceData: PagedResponseModel<InvoiceCashReceiptTableModel> = new PagedResponseModel<InvoiceCashReceiptTableModel>();
  invoiceHeader: ColumnResponseModel[] = [];
  isChargeAccount: boolean = false;
  isOpened: string | undefined = undefined;
  limit: number = 10;
  nameWindow: string = 'Recibos de Caja';
  page: number = 1;
  paymentHeader: ColumnResponseModel[] = [];
  paymentData: PagedResponseModel<CashReceiptPaymentTableModel> = new PagedResponseModel<CashReceiptPaymentTableModel>();
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = "";
  userAuthenticated: UserModel = new UserModel();

  constructor(private cashReceiptService: CashReceiptService,
    private cashReceiptPaymentService: CashReceiptPaymentService,
    private headerService: HeaderService,
    private invoiceCashReceiptService: InvoiceCashReceiptService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.getPermission();
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem('cash-receipt');
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getCashReceiptsWithPagination(),
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  createNewRegister() {
    if (this.permissionUpdatable) {
      this.isChargeAccount ? this.router.navigate([`/cash-receipt-charge-account/register`]) :
        this.router.navigate([`/cash-receipt/register`]);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear recibos de caja. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async exportCashReceiptPaymentsConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(
          this.cashReceiptPaymentService.exportCashReceiptPaymentsConsultation(this.isChargeAccount, this.filters, this.columnSort, this.ascendant)
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Formas de Pago Recibos de caja.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar las formas de pago de los recibos de caja.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar las formas de pago de recibos de caja, comuniquese con el administrador del sistema.'
      );
    }
  }

  async exportGeneralConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(
          this.cashReceiptService.exportGeneralConsultation(this.isChargeAccount, this.filters, this.columnSort, this.ascendant)
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Recibos de caja.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar recibos de caja.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar recibos de caja, comuniquese con el administrador del sistema.'
      );
    }
  }

  async exportInvoiceCashReceiptsConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(
          this.invoiceCashReceiptService.exportInvoiceCashReceiptsConsultation(this.isChargeAccount, this.filters, this.columnSort, this.ascendant)
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Recibos de caja Detalles.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el detalle de los recibos de caja.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar detalle de recibos de caja, comuniquese con el administrador del sistema.'
      );
    }
  }

  async getCashReceiptsWithPagination() {
    try {
      this.generalData = await firstValueFrom(
        this.cashReceiptService.getAllCashReceiptsWithPagination(this.isChargeAccount, this.page, this.limit, this.columnSort, this.ascendant, this.filters)
      );
    } catch (error) {
      console.error('Error al buscar los recibos de caja.', error);
    }
  }

  async getCashReceiptPaymentsWithPagination() {
    try {
      this.paymentData = await firstValueFrom(
        this.cashReceiptPaymentService.getAllCashReceiptPaymentsWithPagination(
          this.isChargeAccount, this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los metodos de pago de los recibos de caja.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.cashReceiptService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar columnas para la consulta general.', error);
    }
  }

  async getColumnsForInvoicesConsultation() {
    try {
      if (this.invoiceHeader.length === 0) {
        this.invoiceHeader = await firstValueFrom(this.invoiceCashReceiptService.getColumnsForGeneralConsultation(this.isChargeAccount));
      }
    } catch (error) {
      console.error('Error al buscar columnas para la consulta de detalles.', error);
    }
  }

  async getColumnsForCashReceiptPaymentsConsultation() {
    try {
      if (this.paymentHeader.length === 0) {
        this.paymentHeader = await firstValueFrom(this.cashReceiptPaymentService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar columnas para la consulta de detalles.', error);
    }
  }

  async getInvoiceCashReceiptsWithPagination() {
    try {
      this.invoiceData = await firstValueFrom(
        this.invoiceCashReceiptService.getAllInvoiceCashReceiptsWithPagination(this.isChargeAccount, this.page, this.limit, this.columnSort, this.ascendant, this.filters)
      );
    } catch (error) {
      console.error('Error al buscar las facturas de los recibos de caja.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    url == 'cash-receipt' ? this.isChargeAccount = false : this.isChargeAccount = true;
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al obtener el perfil de permisos por URL.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    if (this.isChargeAccount) {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceiptChargeAccount));
    } else {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceipt));
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.invoiceHeader.length = this.invoiceHeader.length === 1 ? 0 : this.invoiceHeader.length;
    this.paymentHeader.length = this.paymentHeader.length === 1 ? 0 : this.paymentHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getCashReceiptsWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForInvoicesConsultation(),
          this.getInvoiceCashReceiptsWithPagination()
        ]);
        this.invoiceData = {
          ...this.invoiceData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 2:
        await Promise.all([
          this.getColumnsForCashReceiptPaymentsConsultation(),
          this.getCashReceiptPaymentsWithPagination()
        ]);
        this.paymentData = {
          ...this.paymentData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  onAction(event: { action: string, item?: any, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.isChargeAccount ? this.router.navigate([`/cash-receipt-charge-account/register/${event.item.id}`]) :
        this.router.navigate([`/cash-receipt/register/${event.item.id}`]);
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportInvoiceCashReceiptsConsultation();
        break;
      case 2:
        await this.exportCashReceiptPaymentsConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getCashReceiptsWithPagination()
        break;
      case 1:
        await this.getInvoiceCashReceiptsWithPagination()
        break;
      case 2:
        await this.getCashReceiptPaymentsWithPagination()
        break;
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

}
